<script>
import formatPrice from '@/v-shop/helpers/format-price'

export default {
	props: {
		ProductPage: {
			type: Object,
			required: true,
		},
		qtyModel: {
			type: Number,
			default: 1,
		},
	},
	model: {
		prop: 'qtyModel',
		event: 'updateQtyModel',
	},
	data() {
		return {
			qty: 1,
		}
	},
	computed: {
		discounts() {
			const config = this.$srv('ProductPromotionSelector', [])
			return config.filter(
				(c) =>
					!c.collectionId || this.ProductPage.product.collectionsIds.some((id) => id == c.collectionId)
			)
		},
	},
	methods: {
		setQty(qty) {
			this.qty = Number(qty)
		},
		evaluateContent({ mainText, secondaryText, cartProductQty, discountPct }) {
			const doEval = (expression) => {
				const money = (amount, opts = {}) => {
					return (
						'<span class="nowrap">' +
						formatPrice(amount, {
							currency: this.ProductPage.ProductPage.selectedVariant.pvPrice.priceConfig.currency.sign,
							...opts,
						}) +
						'</span>'
					)
				}
				const price = this.ProductPage.ProductPage.price
				let fnVars = {
					price,
					discountedUnitPrice: price * (1 - discountPct / 100),
					totalPriceWithDiscount: price * (1 - discountPct / 100) * cartProductQty,
					totalPrice: price * cartProductQty,
					money,
				}

				let fnStr = `
					let { ${Object.keys(fnVars).join(', ')} } = fnVars
					return ${expression}
				`
				let func = new Function('fnVars', fnStr)
				return func(fnVars)
			}

			try {
				const html = `
					<div class="font-2">${mainText.replace(/{{(.*?)}}/g, (_, expression) => doEval(expression)).trim()}</div>
					${
						secondaryText
							? `<div>${secondaryText
									.replace(/{{(.*?)}}/g, (_, expression) => doEval(expression))
									.trim()}</div>`
							: ''
					}
				`
				return html
			} catch (error) {
				console.error(error)
				return
			}
		},
		disabled(discount) {
			return (
				this.ProductPage.outOfStock ||
				(this.ProductPage.selectedVariant.stock.qty < discount.cartProductQty &&
					!this.ProductPage.selectedVariant.stock.infiniteQty)
			)
		},
	},
	watch: {
		qty(value) {
			this.$emit('updateQtyModel', value)
		},
		qtyModel(value) {
			this.setQty(value)
		},
	},
}
</script>

<template>
	<div v-if="discounts.length">
		<div class="font-3">Seleccioná tu promoción</div>
		<div class="px-4 py-2">
			<Button
				v-for="(discount, n) in discounts"
				:key="n"
				@click="setQty(discount.cartProductQty)"
				:outlined="discount.cartProductQty != qty"
				class="w100 my-1"
				style="height: unset"
				:style="
					typeof discount.color === 'string' && discount.cartProductQty != qty
						? { 'border-color': discount.color, color: discount.color + '!important' }
						: {}
				"
				:color="discount.color || 'cta'"
				:disabled="disabled(discount)"
			>
				<div class="py-1" v-html="evaluateContent(discount)"></div>
			</Button>
		</div>
	</div>
</template>

